import Grid from '@material-ui/core/Grid';
import React from "react";
import { Link } from "gatsby";

const Post = ({ title, author, date, description, path, imagesrc }) => (
  <Grid container style={{justifyContent: 'center'}}>
    <Grid xs={12} sm={6} md={5} style={{marginRight: 20, marginLeft: 20, marginBottom: 40}}>
      <div>
        <div className="blogTitle">
          <Link to={path} className="blogTitle">{title}</Link>
        </div>
        <div className="createdDate">{date}</div>
        <p className="blogDescriptionP">{description}</p>
        <div className="authorComponent">
          <div className="authorName">{"Posted by " + author}</div>
        </div>
      </div>
    </Grid>
    <Grid xs={12} sm={6} md={4} style={{marginRight: 20, marginLeft: 20, marginBottom: 40}}>
      <img className="imageBorder" src={imagesrc} alt={title}/>
    </Grid>
  </Grid>
);

export default Post;
